var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"svg-icon",class:_vm.wrapperClass},[_c('img',{class:_vm.extraClass,attrs:{"src":("img/myle/svg/" + _vm.icon + ".svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }